import pre from './pre';
import post from './post';
import cart from './cart.vue';
import success from './success.vue';
import addon from './addon.vue';

export default {
  pre,
  components: {
    config: null,
    cart,
    addon,
    success,
  },
  post,
};
